// AWS WAF client helpers. Each no-ops unless the WAF scripts have loaded their globals
// (window.AwsWafIntegration for the token, window.AwsWafCaptcha for the puzzle).

// The current WAF token (the SDK acquires and caches it on page load), or null.
export async function getAwsWafToken() {
  try {
    return (await window.AwsWafIntegration?.getToken()) ?? null;
  } catch (e) {
    return null;
  }
}

// A terminating WAF CAPTCHA action -- HTTP 405 with `x-amzn-waf-action: captcha` -- that
// the loaded puzzle SDK can handle.
export function isAwsWafCaptchaResponse(res) {
  return (
    res.status === 405 &&
    res.headers.get('x-amzn-waf-action') === 'captcha' &&
    Boolean(window.AwsWafCaptcha)
  );
}

// Renders the CAPTCHA puzzle in a modal overlay; resolves once solved (a valid token is
// then available via getAwsWafToken), rejects if unconfigured or the puzzle errors.
export function solveAwsWafCaptcha() {
  const apiKey = window.__DPL_AWS_WAF_CAPTCHA_API_KEY;

  if (!window.AwsWafCaptcha || !apiKey) {
    return Promise.reject(new Error('AWS WAF CAPTCHA is unavailable'));
  }

  return new Promise((resolve, reject) => {
    const overlay = document.createElement('div');
    overlay.dataset.testid = 'aws-waf-captcha-overlay';
    Object.assign(overlay.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: '2147483647',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    });

    const box = document.createElement('div');
    Object.assign(box.style, {
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '20px',
      maxWidth: '100%'
    });

    const container = document.createElement('div');
    box.appendChild(container);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    function cleanup() {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    }

    window.AwsWafCaptcha.renderCaptcha(container, {
      apiKey,
      onSuccess: () => {
        cleanup();
        resolve();
      },
      onError: error => {
        cleanup();
        reject(
          error instanceof Error ? error : new Error('AWS WAF CAPTCHA failed')
        );
      }
    });
  });
}
